<!-- Page Title -->
<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content text-white">
                    <h2>Das Team</h2>
                    <ul class="text-gray-200">
                        <li><a routerLink="/" class="hover:underline">Startseite</a></li>
                        <li>Das Team</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape hidden md:block">
        <div class="shape-1"><img src="assets/img/shape/1.png" alt="shape" /></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/2.png" alt="shape" /></div>
        <div class="shape-3"><img src="assets/img/shape/3.svg" alt="shape" /></div>
        <div class="shape-4"><img src="assets/img/shape/4.svg" alt="shape" /></div>
        <div class="shape-5"><img src="assets/img/shape/5.png" alt="shape" /></div>
    </div>
</div>

<!-- Das Team Content -->
<section class="py-20 bg-white">
    <div class="container mx-auto px-4 max-w-4xl text-gray-800">
        <div class="container">
            <div class="section-title">
                <h2>Unser Fahrlehrer-Team</h2>
                <div class="bar"></div>
                <p>Unsere Fahrlehrer stehen dir mit Erfahrung, Geduld und Motivation zur Seite – für eine erfolgreiche und angenehme Führerscheinausbildung.</p>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="single-team">
                        <div class="image">
                            <!--img src="assets/img/team/team0.png" alt="image"-->

                            <ul class="social">
                                <li><a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="#" target="_blank"><i class="fab fa-twitter"></i></a></li>
                                <li><a href="#" target="_blank"><i class="fab fa-instagram"></i></a></li>
                                <li><a href="#" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>
                            </ul>

                            <div class="content">
                                <h3>Thomas Dayan</h3>
                                <p>Inhaber & Fahrlehrer (Klasse B/BE/B96)</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="single-team">
                        <div class="image">
                            <!--img src="assets/img/team/team2.png" alt="image"-->

                            <ul class="social">
                                <li><a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="#" target="_blank"><i class="fab fa-twitter"></i></a></li>
                                <li><a href="#" target="_blank"><i class="fab fa-instagram"></i></a></li>
                                <li><a href="#" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>
                            </ul>

                            <div class="content">
                                <h3>Bahzet Yüsün</h3>
                                <p>Fahrlehrer (Klasse B/BE/B96)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>
<app-subscribe></app-subscribe>
